import styled, { keyframes } from 'styled-components';
import { COLOR } from '../../../assets/constants/constants'

const { quaternary, secondary } = COLOR;

const fadeIn = keyframes`
  0% { opacity: 0 }
  100% { opacity: 1 }
`

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: calc(30px${p => p.height ? `+ ${p.height}px` : ''});
  margin-top: 12px;
  transition: all .3s ease-out;

  @media (min-width: 768px) and (max-height: 700px){
    height: calc(28px${p => p.height ? `+ ${p.height}px` : ''});
  }

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 1px;
    transform-origin: center;
    background: ${secondary};
    transition: all .3s ease-out;
  }

  &.divisor {
    border-bottom: #eceded solid 1px;
    margin-top: 12px;
    &.active {
      border-bottom: #aedbd9 solid 2px;
      div{
        color: #aedbd9;
      }
    }
  }

  &.active {
    p {
      font-weight: bold;
    }

    &:after {
      background: #2d5a64;
      transform: scaleY(3);
    }
    
  }
`
export const Button = styled.div`
  width: 100%;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (min-width: 768px) and (max-height: 700px){
    height: 28px;
  }

  svg {
    width: 20px;
    height: 20px;
    opacity: 0;
    transition: all .3s ease-out;
    animation: ${fadeIn} .7s ease-out forwards;
  }

  &:hover {
    p {
      color: #aedbd9;
    }

    svg {
      color: #aedbd9;
    }
  }
`

export const TitleWrapper = styled.p`
  font-family: 'Amorim Sans Book';
  text-transform: uppercase;
  font-size: 18px;
  letter-spacing: .6px;
  letter-spacing: 1px;
  color: ${secondary};
  margin-bottom: 0;
  transition: all .3s ease-out;

  @media (min-width: 768px) and (max-height: 700px){
    font-size: 13px;
  }
`

export const SubMenu = styled.ul`
  width: 100%;
  height: auto;
  transition: all .3s ease-out;
  list-style: none;
  margin-top: 10px;
`

export const SubMenuButton = styled.li`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  padding: 6px 0 ;
  font-family: 'Amorim Sans Book';
  text-transform: uppercase;
  font-size: 15px;
  cursor: pointer;
  letter-spacing: .6px;
  color: ${secondary};
  transition: all .3s ease-out;
  margin-bottom: .4rem;
  opacity: 0;
  animation: ${fadeIn} .7s ease-out forwards ${p => p.delay}s;

  &.active {
    color: ${quaternary};
    &:after {
      background: #2d5a64;
      transform: scaleY(2);
    }
  }
  
  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 1px;
    transform-origin: center;
    background: ${secondary};
    transition: all .3s ease-out;
  }

  &:hover {
    color: ${quaternary};
  }
`